import axios, {AxiosResponse} from 'axios'
import {CancellationReason, CancellationReasonQueryResponse, CancellationReasonShort, ResponseObject} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const CANCELLATION_REASON_URL = `${API_URL}/CancellationReason`

const getAllData = (query: string): Promise<CancellationReasonQueryResponse> => {
  return axios
    .get(`${CANCELLATION_REASON_URL}?${query}`)
    .then((d: AxiosResponse<CancellationReasonQueryResponse>) => d.data)
}

const getById = (code: number): Promise<CancellationReason | undefined> => {
  return axios
    .get(`${CANCELLATION_REASON_URL}/${code}`)
    .then((response: AxiosResponse<{data: CancellationReason}>) => response.data.data)
}

const getActiveByUserType = (userType: string): Promise<CancellationReasonShort[]> => {
  return axios
    .get(`${CANCELLATION_REASON_URL}/active/${userType}`)
    .then((response: AxiosResponse<{data: CancellationReasonShort[]}>) => response.data.data)
}

const createDataRecord = (data: CancellationReason): Promise<ResponseObject | undefined> => {
  return axios
    .post(CANCELLATION_REASON_URL, data)
    .then((response: AxiosResponse<ResponseObject>) => response.data)
}

const updateDataRecord = (data: CancellationReason): Promise<ResponseObject | undefined> => {
  return axios
    .put(CANCELLATION_REASON_URL, data)
    .then((response: AxiosResponse<ResponseObject>) => response.data)
}

const deleteDataRecord = (code: number): Promise<ResponseObject | undefined> => {
  return axios
    .delete(`${CANCELLATION_REASON_URL}/${code}`)
    .then((response: AxiosResponse<ResponseObject>) => response.data)
}

export {getAllData, getById, getActiveByUserType, createDataRecord, updateDataRecord, deleteDataRecord}
